import { useGetDataQuery } from 'common/commonRedux/getRTKApi/baseApi';
import { useSelector } from 'react-redux';

interface Designations {
  intDesignationId: number;
  isActive: boolean;
  strDesignationName: string;
}
export const useDesignations = (): {
  designations: Designations[];
  refetchDesignations: any;
  designationFetching: boolean;
} => {
  const { accountid } = useSelector(
    (state: any) => state.auth?.profileData?.tokenData
  );

  const {
    data: designations = [],
    refetch: refetchDesignations,
    isFetching,
  } = useGetDataQuery(
    { params: { accountid }, urlObjKey: 'GetDesignations' },
    { skip: accountid === undefined }
  );
  return { designations, refetchDesignations, designationFetching: isFetching };
};
